var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOurClient3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234,
    height: 158,
    viewBox: "0 0 234 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 233,
    height: 157,
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M61.3556 78.385C61.296 77.9351 61.2672 77.4897 61.2672 77.0487V75.5197C61.2672 74.6442 61.3947 73.7476 61.6498 72.8298C61.9049 71.914 62.3233 71.0839 62.9053 70.3396C63.4859 69.5965 64.2562 68.9853 65.215 68.5066C66.1737 68.0279 67.3568 67.7885 68.7641 67.7885H69.0704C70.2746 67.7885 71.2994 67.9313 72.146 68.2161C72.9926 68.5021 73.7116 68.8938 74.3032 69.3937C74.8947 69.8929 75.3587 70.4785 75.6958 71.1505C76.0322 71.8231 76.2623 72.5655 76.3841 73.3809H79.3225C79.159 72.0362 78.8111 70.8599 78.2823 69.8513C77.7504 68.8426 77.0519 68.003 76.186 67.3303C75.3189 66.6577 74.2878 66.1585 73.0951 65.8334C71.9012 65.507 70.5598 65.3438 69.0704 65.3438H68.7641C67.1318 65.3438 65.6636 65.5735 64.3588 66.0311C63.052 66.4893 61.9452 67.146 61.0378 68.0029C60.1303 68.858 59.4324 69.9178 58.9415 71.1812C58.4525 72.4446 58.207 73.8903 58.207 75.5197V77.0487C58.207 77.5082 58.225 77.9537 58.2609 78.385H61.3556Z",
    fill: "#021A1A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M75.8469 81.4787C75.4893 82.1929 75.0099 82.8137 74.4088 83.3437C73.8064 83.8736 73.0662 84.2857 72.1895 84.5808C71.3127 84.8771 70.272 85.0237 69.0684 85.0237H68.7621C67.3547 85.0237 66.1768 84.7856 65.2277 84.3056C64.2798 83.8281 63.5095 83.2016 62.918 82.4265V86.2742C63.3666 86.5206 63.8479 86.735 64.3561 86.9187C65.6609 87.3865 67.1298 87.6214 68.7614 87.6214H69.0678C70.5572 87.6214 71.894 87.4525 73.0771 87.1165C74.2601 86.7805 75.3009 86.2614 76.1981 85.5587C77.096 84.856 77.8343 83.9747 78.4162 82.9149C78.9981 81.8563 79.3999 80.6141 79.6242 79.1875H76.5653C76.4423 80.0022 76.2026 80.7664 75.8463 81.4787H75.8469Z",
    fill: "#021A1A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M95.6276 72.4183C94.9239 71.7361 94.0254 71.1959 92.9346 70.7985C91.8432 70.401 90.5525 70.2026 89.0638 70.2026C87.575 70.2026 86.1971 70.401 85.1166 70.7985C84.0348 71.1959 83.1427 71.7354 82.4391 72.4183C81.7354 73.1012 81.2195 73.9057 80.8939 74.8324C80.5671 75.7598 80.4043 76.7626 80.4043 77.8423V79.6759C80.4043 80.7562 80.5773 81.7745 80.9247 82.7319C81.2714 83.69 81.8014 84.5303 82.516 85.2535C83.2299 85.9767 84.1271 86.5521 85.2089 86.9796C86.2901 87.4071 87.575 87.6215 89.0644 87.6215C90.5538 87.6215 91.7727 87.4078 92.8436 86.9796C93.9145 86.5521 94.8175 85.9767 95.5519 85.2535C96.2864 84.5303 96.8266 83.69 97.174 82.7319C97.5207 81.7745 97.6944 80.7562 97.6944 79.6759V77.8423C97.6944 76.7626 97.5258 75.7598 97.1894 74.8324C96.8523 73.9057 96.3325 73.1012 95.6288 72.4183H95.6276ZM94.6329 79.6759C94.6329 80.6334 94.49 81.4538 94.2048 82.1361C93.919 82.819 93.521 83.3738 93.0115 83.8014C92.5014 84.2289 91.9047 84.545 91.2216 84.7486C90.5378 84.9527 89.8187 85.0538 89.0644 85.0538C88.3101 85.0538 87.5596 84.9578 86.8765 84.7639C86.1927 84.5706 85.6011 84.2545 85.1019 83.8167C84.602 83.379 84.204 82.8234 83.9086 82.1514C83.6125 81.4788 83.4651 80.6538 83.4651 79.6759V77.8423C83.4651 77.0071 83.6029 76.2686 83.8785 75.6266C84.154 74.9847 84.5366 74.4401 85.0256 73.9921C85.5152 73.5441 86.1016 73.2081 86.7855 72.9834C87.4686 72.7594 88.2287 72.6474 89.065 72.6474C89.9014 72.6474 90.5999 72.7594 91.2837 72.9834C91.9669 73.2081 92.5584 73.5441 93.0583 73.9921C93.5582 74.4401 93.9459 74.9854 94.2208 75.6266C94.4964 76.2686 94.6342 77.0071 94.6342 77.8423V79.6759H94.6329Z",
    fill: "#021A1A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M109.368 70.6621L106.007 79.432H109.002L106.276 86.552H105.815L100.123 70.6621H96.9727L103.155 87.1626H108.969L112.038 79.432H109.042L112.521 70.6621H109.368Z",
    fill: "#021A1A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M127.078 72.0362C126.374 71.4455 125.532 70.9924 124.553 70.6762C123.574 70.3607 122.503 70.2026 121.341 70.2026C120.524 70.2026 119.652 70.3095 118.725 70.5233C117.796 70.737 116.939 71.1191 116.154 71.6695C115.368 72.2199 114.711 72.9482 114.18 73.8545C113.649 74.7614 113.385 75.907 113.385 77.2919V80.7146C113.385 81.9978 113.655 83.0782 114.195 83.9537C114.736 84.8298 115.409 85.5377 116.215 86.0772C117.02 86.6174 117.888 87.009 118.816 87.2535C119.744 87.498 120.586 87.6202 121.341 87.6202C123.87 87.6202 125.788 87.0551 127.094 85.9242C128.399 84.794 129.123 83.169 129.266 81.05H126.451C126.41 81.498 126.303 81.962 126.13 82.4401C125.956 82.9194 125.675 83.347 125.288 83.7239C124.901 84.1009 124.39 84.4113 123.759 84.6558C123.126 84.9002 122.32 85.0225 121.341 85.0225C120.709 85.0225 120.091 84.9156 119.49 84.7018C118.888 84.4881 118.352 84.1873 117.883 83.8001C117.414 83.4135 117.042 82.9546 116.766 82.4247C116.49 81.8948 116.353 81.3246 116.353 80.7134V79.4295H129.296V77.1377C129.296 76.058 129.102 75.0852 128.715 74.2193C128.327 73.3534 127.782 72.6257 127.078 72.0343L127.078 72.0362ZM116.352 77.1396V76.8343C116.352 76.2839 116.485 75.7598 116.75 75.2606C117.015 74.7614 117.377 74.3338 117.836 73.9767C118.295 73.6209 118.82 73.3354 119.412 73.121C120.004 72.9073 120.646 72.8004 121.34 72.8004C122.339 72.8004 123.17 72.9278 123.834 73.1825C124.496 73.4372 125.027 73.7738 125.425 74.1911C125.823 74.609 126.103 75.0826 126.266 75.6119C126.43 76.1418 126.511 76.6513 126.511 77.1396H116.352Z",
    fill: "#021A1A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M138.18 70.936C137.252 71.1203 136.477 71.384 135.856 71.7302C135.232 72.0778 134.737 72.5149 134.371 73.0448C134.004 73.5747 133.779 74.1859 133.697 74.8778L133.666 74.817L133.423 74.481L133.759 70.6608H130.699V78.392H133.759V77.8429C133.759 77.8224 133.775 77.695 133.805 77.4608C133.836 77.2272 133.927 76.9558 134.08 76.6499C134.233 76.3453 134.473 76.0093 134.8 75.6426C135.125 75.2758 135.574 74.9437 136.145 74.6493C136.717 74.353 137.446 74.104 138.334 73.9005C139.221 73.697 140.297 73.5946 141.562 73.5946H142.48V70.6602H141.409C140.185 70.6602 139.108 70.753 138.18 70.9354V70.936Z",
    fill: "#021A1A"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M130.396 87.1625H133.432L136.911 78.3926H133.757L130.396 87.1625Z",
    fill: "url(#paint0_radial_1884_36039)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M61.3607 78.3857L58 87.1557H61.0352L64.5145 78.3857H61.3607Z",
    fill: "url(#paint1_radial_1884_36039)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M171.176 65.2178H149.762V89.0085H171.176V65.2178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M171.129 63H150.166C148.524 64.6403 147.603 65.5594 145.961 67.1997V80.3331C145.961 88.433 152.536 95 160.648 95C168.759 95 175.335 88.4336 175.335 80.3331V67.1997C173.692 65.5594 172.772 64.6403 171.129 63H171.129ZM154.89 87.88H150.412L155.109 79.1293H159.485L154.89 87.88H154.89ZM170.883 87.88C160.647 87.88 158.598 71.5261 150.416 71.5261C150.407 67.4378 150.416 67.4378 150.416 67.4378C160.648 67.4378 162.693 83.7917 170.883 83.7917V87.88ZM166.287 76.1878H161.809L166.505 67.4371H170.882L166.286 76.1878H166.287Z",
    fill: "url(#paint2_radial_1884_36039)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1884_36039",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(139.628 100.276) scale(44.0561 43.9962)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#00DF82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#03624C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1884_36039",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.0608 88.0056) scale(23.3578 23.3261)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#00DF82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#00DA80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00CE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#00BA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#019D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#027855"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#03624C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1884_36039",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(158.595 105.502) scale(57.0908 57.0131)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#00DF82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#03624C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurClient3);
export default __webpack_public_path__ + "static/media/our-client-3.ee9cbe5bae5b7cea88092b8b8de5e459c1a025ae860b1ea0418dad6aa0824a41.svg";
export { ForwardRef as ReactComponent };